import React, { useState, useEffect, useRef } from "react";
import { data, useNavigate } from "react-router-dom";
import {
  FaCheckCircle,
  FaCheck,
  FaArrowLeft,
  FaArrowRight,
} from "react-icons/fa";
import { getCurrentUserId } from "../..//utils/auth";
import { Dropdown, Modal, ModalBody } from "reactstrap";
import { getSidebarMenus } from "../../constants/sidebarMenus";
import "../../css/User/MyRevolution.css";
import TopHeader from "../../components/comman/TopHeader";
import Sidebar from "../../components/comman/Sidebar";
import { toast } from "react-toastify";
import api from "../../api/axios";
import pdf from "../../assets/images/pdf/pdf.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon } from "@iconify/react";
import { BsThreeDots } from "react-icons/bs";
import { useProfile } from "../../hook/useProfile";
import { downloadRevolutionPdf } from "../../components/DownloadPdf/DownloadRevolution";
import { FaShareAlt, FaSignature, FaDownload, FaShare } from "react-icons/fa";
import EditRevolution from "../../components/model/EditRevolution";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination } from "swiper/modules";

function AllRevolution() {
  const currentUserId = getCurrentUserId();
  const [feedType, setFeedType] = useState("revolution");
  const [activeSidebar, setActiveSidebar] = useState("revolution-my");
  const { isProfileInfo } = useProfile();
  const pdfRef = useRef(null);
  const [selectedRevolution, setSelectedRevolution] = useState(null);
  const [isRevolution, setIsRevolution] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [revertModal, setRevertModal] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [showRevolutionDrop, setShowRevolutionDrop] = useState(false);
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);
  const [openSignatureId, setOpenSignatureId] = useState(null);
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [activeMedia, setActiveMedia] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const sidebarMenus = getSidebarMenus(currentUserId);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const profileRef = useRef(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isRevolutionID, setISRevolutionId] = useState(null);
  const DropdownRevolution = useRef(null);

  // useEffect(() => {
  //   const handleClickOutside = (e) => {
  //     // alert("clicked outside");
  //     if (
  //       DropdownRevolution.current &&
  //       !DropdownRevolution.current.contains(e.target)
  //     ) {
  //       setisRevolutionActive(null);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".reject-approve-button")) {
        setShowRevolutionDrop(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const handleDownloadPdf = (item) => {
  //   setSelectedRevolution(item);
  //   setTimeout(() => {
  //     pdfRef.current?.downloadPDF();
  //   }, 100);
  // };

  // const updateRevolutionPermission = isRevolution

  const handleRevolutionUpdate = (updatedRevolution) => {
    setIsRevolution((prev) =>
      prev.map((rev) =>
        rev._id === updatedRevolution._id
          ? { ...rev, ...updatedRevolution }
          : rev,
      ),
    );
  };

  useEffect(() => {
    const handleRevolution = async () => {
      try {
        const response = await api.get("revolution/me");
        console.log("FULL API RESPONSE:", response.data);
        console.log("REVOLUTIONS ARRAY:", response.data.data);
        
        if (response.data.data && response.data.data.length > 0) {
          const firstRevolution = response.data.data[0];
          console.log("FIRST REVOLUTION STRUCTURE:", Object.keys(firstRevolution));
          console.log("SUPPORTER IN FIRST REVOLUTION:", firstRevolution.supporters);
          console.log("SUPPORTER TYPE:", typeof firstRevolution.supporters);
          console.log("IS ARRAY:", Array.isArray(firstRevolution.supporters));
          
          if (firstRevolution.supporter && firstRevolution.supporter.length > 0) {
            console.log("FIRST SUPPORTER:", firstRevolution.supporter[0]);
          }
        }
        
        setIsRevolution(response.data.data || []);
        setIsLoading(false);
      } catch (error) {
        console.error("API Error:", error);
        setIsLoading(false);
      }
    };
    handleRevolution();
  }, []);

  const handleRejected = async (id) => {
    try {
      const res = await api.post(`/revolution/${id}/end`);
      toast.success("Revolution Ended Successfully");

      if (res.data.success === true) {
        setISRevolutionId(id);
      }
    } catch (error) {
      setISRevolutionId(null);
      console.log("something went wrong", error);
    }
  };

  /* ================= HELPERS ================= */
  const toggleCard = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      // localStorage.clear();
      navigate("/login");
    }
  };

  /* ===== MEDIA HELPERS ===== */

  const getMediaType = (file) => {
    const url = file.toLowerCase();
    if (url.includes(".mp4")) return "video";
    if (url.includes(".pdf")) return "pdf";

    // if (file.endsWith(".mp4")) return "video";
    // if (file.endsWith(".pdf")) return "pdf";
    return "image";
  };

  const groupMedia = (item) => {
    const { images = [], videos = [], pdfs = [] } = item;
    // console.log(videos , "images")
    const preview = [];

    if (images.length > 0)
      preview.push({ file: images[0], type: "image", count: images.length });
    if (videos.length > 0)
      preview.push({ file: videos[0], type: "video", count: videos.length });
    if (pdfs.length > 0)
      preview.push({ file: pdfs[0], type: "pdf", count: pdfs.length });

    return preview;
  };

  const handleMediaClick = (item, clickedFile) => {
    const type = getMediaType(clickedFile);
    // console.log(type, "type");

    let filtered = [];
    if (type === "image") filtered = item.images || [];
    else if (type === "video") filtered = item.videos || [];
    else if (type === "pdf") filtered = item.pdfs || [];

    setMediaType(type);
    setActiveMedia(filtered);
    setCurrentIndex(filtered.indexOf(clickedFile));
    // console.log(filtered.indexOf(clickedFile), "clickfile");
    setShowMediaModal(true);
  };

  const prevMedia = () => {
    setCurrentIndex((prev) => (prev === 0 ? activeMedia.length - 1 : prev - 1));
  };

  const nextMedia = () => {
    setCurrentIndex((prev) => (prev === activeMedia.length - 1 ? 0 : prev + 1));
  };

  const sendEditRequest = async (revolutionId) => {
    try {
      const res = await api.post(`/revolution/${revolutionId}/request`);
      console.log(res, "edit request sent");
      toast.success("Edit request sent successfully");
    } catch (error) {
      console.log("somethink went wrong", error);
    }
  };

  // External share handler

  // const handleExternalShare = async (post) => {
  //   const shareUrl = ${window.location.origin}/post/${post._id};
  //   const shareUrl =
  //     post?.feedType === "REVOLUTION"
  //       ? ${window.location.origin}/r/${post._id}
  //       : ${window.location.origin}/post/${post._id};

  //   if (navigator.share) {
  //     await navigator.share({
  //       title: "Check this post",
  //       url: shareUrl,
  //     });
  //   } else {
  //     await navigator.clipboard.writeText(shareUrl);
  //     toast.success("Link copied to clipboard");
  //   }

  //   setSharePost(null);
  // };

  const [sharePost, setSharePost] = useState(null);
  const handleExternalShare = async (post) => {
    // console.log(post._id , "mypost")
    // const shareUrl = ${window.location.origin}/post/${post._id};/
    // console.log(post, "post");
    try {
      const type = post?.feedType || "REVOLUTION";

      const shareUrl =
        type === "REVOLUTION"
          ? `${window.location.origin}/r/${post._id}`
          : `${window.location.origin}/post/${post._id}`;

      if (navigator.share) {
        await navigator.share({
          title: "Check this post",
          url: shareUrl,
        });
      } else {
        await navigator.clipboard.writeText(shareUrl);
        toast.success("Link copied to clipboard");
      }

      setSharePost(null);
    } catch (error) {
      console.log("Share failed:", error);
    }
  };

  // Sidebar Menu Error

  // ================= RENDER ================= //

  return (
    <div className="container-xxl p-0">
      <div className="feed-page-wrapper">
        <TopHeader
          onToggleSidebar={() => setShowSidebar((prev) => !prev)}
          onOpenMessages={() => setShowMsgDrawer(true)}
          creditAmount={50}
          notificationCount={5}
          messageCount={0}
        />
        <div className="prime-layout-container .container-fluid">
          <div className="row">
            {!showSidebar && (
              <div
                className="left-sidebar-overlay d-md-none"
                onClick={() => setShowSidebar(true)}
              />
            )}
            <Sidebar
              showSidebar={showSidebar}
              sidebarMenus={sidebarMenus}
              activeSidebar={activeSidebar}
              feedType={feedType}
              // onNavigate={(item) => navigate(item.path)}
              onNavigate={(item) => {
                setActiveSidebar(item.key);
                navigate(item.path);
              }}
              onLogout={handleLogout}
            />

            <div className="col-lg-9 col-md-9 col-12 overflow-auto center-area-container">
              <div className="center-area">
                <div className="w-100 pb-5">
                  <div className="All-Revolation">
                    <div className="approval-wrapper">
                      {isLoading ? (
                        <h6 className="text-secondary text-center">
                          Loading...
                        </h6>
                      ) : isRevolution.length === 0 ? (
                        <h6 className="text-secondary text-center">
                          No Revolutions......
                        </h6>
                      ) : (
                        isRevolution.map((item, idx) => {
                          console.log(item, "item");
                          return (
                            <div key={item._id}>
                              <div className="detail-card">
                                <div className="detail-header-revolution-my">
                                  <div
                                    className="detail-header-myrevolution"
                                    onClick={() => toggleCard(item._id)}
                                  >
                                    <img
                                      src={`${item.from.profilePic}`}
                                      alt="profile"
                                      onError={(e) => {
                                        e.target.src =
                                          "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                                      }}
                                    />
                                    <div>
                                      <h4>
                                        {item.from.fullName}
                                        {isProfileInfo.adhaarVerified ===
                                          "VERIFIED" && (
                                          <Icon icon="ic:baseline-verified" />
                                        )}
                                      </h4>
                                      <small>
                                        {new Date(
                                          item.createdAt,
                                        ).toLocaleDateString()}
                                      </small>
                                    </div>
                                    <div className="status-pending">
                                      <h2
                                        className={`${item.status === "PENDING" ? "pending" : item.status === "ACCEPTED" ? "accepted" : "rejected"}`}
                                      >
                                        {isRevolutionID === item._id
                                          ? "END REVOLUTION"
                                          : item.status}
                                      </h2>
                                    </div>
                                  </div>

                                  <div className="reject-approve-button">
                                    {isRevolution[idx].status !==
                                      "END REVOLUTION" &&
                                      isRevolutionID !== item._id && (
                                        <>
                                          <BsThreeDots
                                            onClick={() =>
                                              setShowRevolutionDrop(
                                                showRevolutionDrop === item._id
                                                  ? null
                                                  : item._id,
                                              )
                                            }
                                          />

                                          {showRevolutionDrop === item._id && (
                                            <div className="detail-header-revolution-my">
                                              {(item?.status ==="UPDATE REQUEST"  ||
                                               item?.status === "REJECTED"  ||
                                                item?.status === "PENDING") && (
                                                <button
                                                  onClick={() => {
                                                    setSelectedRevolution({
                                                      data: item,
                                                    });
                                                    setShowEditModal(true);
                                                  }}
                                                >
                                                  Edit Revolution
                                                </button>
                                              )}

                                              <button
                                                onClick={() =>
                                                  handleRejected(item._id)
                                                }
                                              >
                                                End Revolution
                                              </button>
                                            </div>
                                          )}
                                        </>
                                      )}
                                  </div>
                                </div>

                                <div className="revolution-all-details">
                                  <div className="rev-text">
                                    <p>
                                      <strong>To:</strong> {item.to}
                                    </p>
                                    <p>
                                      <strong>Subject:</strong> {item.title}
                                    </p>
                                    <p>
                                      <strong>Description:</strong>{" "}
                                      {item.description}
                                    </p>
                                  </div>

                                  {/* MEDIA */}
                                  <div className="revolution-post-image">
                                    {groupMedia(item).map(
                                      (media, index, arr) => {
                                        const fileUrl = `${media.file}`;
                                        // console.log(fileUrl?.images.length , "fileurl")
                                        // console.log(media, "media")
                                        return (
                                          <div
                                            key={index}
                                            className="media-box"
                                            onClick={() =>
                                              handleMediaClick(item, media.file)
                                            }
                                          >
                                            {media.type === "image" && (
                                              <div className="revolution_img">
                                                <>
                                                  <img
                                                    src={fileUrl}
                                                    alt="media"
                                                  />
                                                  {index === 0 && (
                                                    <span className="img_length">
                                                      <p>Image's</p>
                                                      {media?.count || 0}
                                                    </span>
                                                  )}
                                                </>
                                              </div>
                                            )}
                                            {media.type === "video" && (
                                              <div className="revolution_img">
                                                <video
                                                  src={fileUrl}
                                                  autoPlay
                                                  muted
                                                  controls
                                                  loop
                                                />
                                                {index === 1 && (
                                                  <span className="img_length">
                                                    <p>video's</p>
                                                    {media?.count}
                                                  </span>
                                                )}
                                              </div>
                                            )}
                                            {media.type === "pdf" && (
                                              <div className="revolution_img">
                                                <div className="pdf-preview">
                                                  <img src={pdf} alt="pdf" />
                                                </div>
                                                {index === 2 && (
                                                  <span className="img_length">
                                                    <p>PDF's</p>
                                                    {media?.count}
                                                  </span>
                                                )}
                                              </div>
                                            )}
                                            {media.count > 1 && (
                                              <div className="media-count-badge">
                                                {media.count}
                                              </div>
                                            )}
                                          </div>
                                        );
                                      },
                                    )}
                                  </div>

                                  <div className="approval-footer">
                                    <div className="supporter">
                                      <p>
                                        <span className="theme-color me-1">
                                          {item.supporterCount || 0}
                                        </span>
                                        Supported
                                      </p>
                                    </div>
                                    <div className="footer-right">
                                      {/* {console.log("FINAL CHECK:", {
                                        supporter: item.supporters,
                                        supporterLength: item.supporters?.length,
                                        supporterCount: item.supporterCount
                                      })} */}

                                      {item.supporters?.length > 0 && (
                                          <FaSignature
                                          className="sign-icon"
                                          onClick={() =>
                                            setOpenSignatureId(
                                              openSignatureId === item._id ? null : item._id
                                            )
                                          }
                                        />
                                      )}

                                      <FaDownload
                                        className="download-icon"
                                        onClick={() => {
                                          console.log("========== PDF DEBUG ==========");
                                          console.log("Full revolution object:", JSON.stringify(item, null, 2));
                                          console.log("Supporter array:", item.supporters);
                                          console.log("Supporter count:", item.supporterCount);
                                          console.log("Supporter type:", typeof item.supporters);
                                          console.log("Is supporter an array?", Array.isArray(item.supporters));

                                          if (item.supporters && item.supporters.length > 0) {
                                            console.log("First supporter:", item.supporters[0]);
                                          }

                                          downloadRevolutionPdf(item);
                                        }}
                                      />

                                      <FaShare
                                        onClick={() => handleExternalShare(item)}
                                      />
                                    </div>
                                    {/* ===== Digital Signature Card (UNCHANGED UI) ===== */}
                                  </div>
                                </div>
                                {openSignatureId === item._id && (
                                  <div className="signature-container">
                                    {item.supporters?.map((sup, idx) => (
                                      <div key={idx} className="signature-card">
                                        <div className="signature-left">
                                          <img
                                            src={`${sup.profilePic}`}
                                            alt="profile"
                                            onError={(e) => {
                                              e.target.src =
                                                "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                                            }}
                                            className="signature-profile"
                                          />

                                          <div className="signature-info">
                                            <div className="verified_badge_revolution">
                                              <h4>{sup.fullName}</h4>
                                              <span className="verified-badge-myprofile">
                                                <FaCheck />
                                              </span>
                                            </div>
                                            <p>{sup.phone}</p>
                                            <p>
                                              {sup.districtPrivate},{" "}
                                              {sup.statePrivate}
                                            </p>
                                            <p>
                                              {new Date(
                                                sup.createdAt,
                                              ).toLocaleDateString()}
                                            </p>
                                          </div>
                                        </div>

                                        <div className="signature-image">
                                          <img
                                            src={`${sup.digitalSignature}`}
                                            alt="digital-signature"
                                          />
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {showEditModal && (
              <EditRevolution
                onOpen={showEditModal}
                onClose={() => setShowEditModal(false)}
                data={selectedRevolution.data}
                onUpdate={handleRevolutionUpdate}
              />
            )}
          </div>
        </div>

        {/* <Modal
          isOpen={showMediaModal}
          toggle={() => setShowMediaModal(false)}
          size="lg"
          centered
          className="media-modal"
        >
          <ModalBody className="media-slider-body">
            <button className="slider-btn left" onClick={prevMedia}>
              <FaArrowLeft />
            </button>

            {mediaType === "image" && (
              <img
                src={`${activeMedia[currentIndex]}`}
                className="media-full"
                alt="img"
              />
            )}
            {mediaType === "video" && (
              <video
                src={`${activeMedia[currentIndex]}`}
                controls
                className="media-full"
              />
            )}

            {mediaType === "pdf" && (
              // <iframe
              //   src={`${activeMedia[currentIndex]}`}
              //   className="media-full"
              //   // title="pdf"
              // />

              <iframe
                src={`https://docs.google.com/gview?url=${encodeURIComponent(activeMedia[currentIndex])}&embedded=true`}
                className="media-full"
              />
            )}

            <button className="slider-btn right" onClick={nextMedia}>
              <FaArrowRight />
            </button>
          </ModalBody>
        </Modal> */}

        <Modal
          isOpen={showMediaModal}
          toggle={() => setShowMediaModal(false)}
          size="lg"
          centered
          className="media-modal"
        >
          <ModalBody className="media-slider-body">
            <Swiper
              modules={[Navigation, Pagination]}
              navigation
              pagination={{ clickable: true }}
              spaceBetween={10}
              slidesPerView={1}
              initialSlide={currentIndex}
              className="media-swiper"
            >
              {activeMedia.map((media, index) => {
                const type = getMediaType(media);

                return (
                  <SwiperSlide key={index}>
                    <div className="media-wrapper">
                      {type === "image" && (
                        <img src={media} className="media-full" alt="img" />
                      )}

                      {type === "video" && (
                        <video src={media} controls className="media-full" />
                      )}

                      {type === "pdf" && (
                        <iframe
                          src={`https://docs.google.com/gview?url=${encodeURIComponent(media)}&embedded=true`}
                          className="media-full"
                          title="pdf"
                        />
                      )}
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
}

export default AllRevolution;
